'use strict';
/**
 * Checks if the given module is loaded. If the module is not loaded the element is removed
 */
angular.module('cfn').directive('dRemoveIfNoModule', [
  'moduleLoading',
  function(moduleLoading) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        if (!moduleLoading.isModuleKnown(attrs.dRemoveIfNoModule, true)) {
          element.remove();
        }
      }
    };
  }
]);
